import { FC } from 'react';
import { useAppSelector } from '@redux/hooks';
import { ScrollBar } from '@ui-kit/ScrollBar';
import { MyLink, LinkTheme } from '@app/shared';
import { RowLinksTypeProps } from './TypeProps';
import classNames from 'classnames';

import styles from './RowLinks.module.scss';

export const RowLinks: FC<RowLinksTypeProps> = ({ className, links }) => {
  const host = useAppSelector(state => state.header.data.host);
  return (
    <div className={classNames(styles.WrapperRowLinks, className)}>
      <ScrollBar classContainer={styles.Container} type="horizontal">
        {links.map(link => (
          <MyLink reloaded themes={LinkTheme.Theme8} key={link.title} href={host + link.href}>
            {link.title}
          </MyLink>
        ))}
      </ScrollBar>
    </div>
  );
};
